/*
 * CUSTOM: Digital Product Passport (Carbonfact) — lazy iframe embed inside a modal
 *
 * The DPP block lives inside the "liquid" product-info block, which is swapped on every
 * partial rerender (theme.js onRerender_fn, element.replaceWith). So on each variant change
 * the modal + iframe are a fresh node carrying an up-to-date data-dpp-src (the selected
 * variant's dpp-id, rendered server-side in custom-product-tabs-impact.liquid).
 *
 * This controller lives globally (loaded on the PDP, outside the swapped fragment) and only
 * sets the iframe src when the modal opens: the embed is fetched on demand — not on every PDP
 * load or variant rerender — and always reflects the currently selected variant. The src is
 * cleared on close so a reopen after a variant change loads the new passport.
 *
 * dialog:before-show / dialog:after-hide are dispatched without bubbling (theme.js x-modal),
 * so they are caught in the capture phase at document. The modal is moved to document.body
 * while open; the embed container + iframe move with it.
 */
(() => {
  if (window.__mmDppInit) return;
  window.__mmDppInit = true;

  const MODAL_SELECTOR = 'x-modal[id^="custom-dpp-modal-"]';

  const setSrc = (modal) => {
    const embed = modal.querySelector('.custom-dpp-embed');
    const iframe = embed && embed.querySelector('iframe');
    if (!embed || !iframe) return;
    const src = embed.getAttribute('data-dpp-src');
    if (src && iframe.getAttribute('src') !== src) iframe.setAttribute('src', src);
  };

  const clearSrc = (modal) => {
    const iframe = modal.querySelector('.custom-dpp-embed iframe');
    if (iframe && iframe.hasAttribute('src')) iframe.removeAttribute('src');
  };

  // Load early (on open animation) for a head start; both events do not bubble -> capture phase.
  document.addEventListener('dialog:before-show', (event) => {
    const el = event.target;
    if (el instanceof Element && el.matches(MODAL_SELECTOR)) setSrc(el);
  }, true);

  document.addEventListener('dialog:after-hide', (event) => {
    const el = event.target;
    if (el instanceof Element && el.matches(MODAL_SELECTOR)) clearSrc(el);
  }, true);
})();
